"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FieldBlock = _interopRequireDefault(require("../../../../../components/FieldBlock"));

var _common = _interopRequireDefault(require("../../../../../styles/common.css"));

var _reactSelect = _interopRequireDefault(require("react-select"));

require("react-select/less/default.less");

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StringValue =
/*#__PURE__*/
function (_React$Component) {
  _inherits(StringValue, _React$Component);

  function StringValue() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, StringValue);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StringValue)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onSelectboxChange", function (value) {
      _this.props.field.onChange(value.map(function (n) {
        return n.value;
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (e) {
      var value = e.target.value ? e.target.value.split(',') : [];

      _this.props.field.onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "renderSelectbox", function () {
      var _this$props = _this.props,
          field = _this$props.field,
          possibleValues = _this$props.possibleValues;
      return _react.default.createElement("div", {
        className: "".concat(_common.default.lastRow, " ").concat(_style.default.wrapper)
      }, _react.default.createElement(_FieldBlock.default, {
        field: field,
        label: ""
      }, _react.default.createElement(_reactSelect.default, {
        name: "selectbox",
        value: field.value,
        options: possibleValues,
        onChange: _this.onSelectboxChange,
        clearable: false,
        deleteRemoves: false,
        searchable: false,
        multi: true
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function () {
      var field = _this.props.field;
      return _react.default.createElement("div", {
        className: _common.default.lastRow
      }, _react.default.createElement(_FieldBlock.default, {
        field: field,
        label: ""
      }, _react.default.createElement("input", {
        className: "form-control",
        onChange: _this.onInputChange,
        placeholder: "Comma separated values",
        value: field.value
      })));
    });

    return _this;
  }

  _createClass(StringValue, [{
    key: "render",
    value: function render() {
      return this.props.possibleValues ? this.renderSelectbox() : this.renderInput();
    }
  }]);

  return StringValue;
}(_react.default.Component);

exports.default = StringValue;

_defineProperty(StringValue, "propTypes", {
  field: _propTypes.default.object,
  possibleValues: _propTypes.default.array
});